import { render, staticRenderFns } from "./ServicesDetails.vue?vue&type=template&id=23e17fd1&scoped=true&"
import script from "./ServicesDetails.vue?vue&type=script&lang=js&"
export * from "./ServicesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e17fd1",
  null
  
)

export default component.exports